// extracted by mini-css-extract-plugin
export default {"section_content":"cookies_policy_section_content__LrqY7","pere_content_box":"cookies_policy_pere_content_box__8qjyP"};